var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-pane fade",attrs:{"role":"tabpanel","aria-labelledby":("tabs-" + _vm.tabId + "-tab"),"id":("tabs-" + _vm.tabId),"data-title":_vm.title,"data-tab-id":_vm.tabId}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }